import React from 'react'
import { Redirect } from 'react-router-dom'
import { departmentList } from '../Departments/constants'

import Page from './page'

const departmentData = {
  'customer_experience': {
    description: 'We are crafters and guides for our customers in their journey of the future',
    style: {
      small: {
        backgroundImage: 'url(https://d2u7nrdrppwhsn.cloudfront.net/career/department_cx_2018-05.jpg)',
      },
      big: {
        backgroundImage: 'url(https://d2u7nrdrppwhsn.cloudfront.net/career/department_cx_2018-05.jpg)',
      },
    },
  },
  data: {
    description: `We uncover hidden insights and predict the future\nQuite the wizards, really`,
    style: {
      small: {
        backgroundImage: 'url(https://d2u7nrdrppwhsn.cloudfront.net/career/data.jpg)',
        backgroundPosition: 'left',
      },
      big: {
        backgroundImage: 'url(https://d2u7nrdrppwhsn.cloudfront.net/career/data.jpg)',
        backgroundPosition: 'left',
      },
    },
  },
  finance: {
    description: 'We build and execute with clarity, integrity and quality',
    style: {
      small: {
        backgroundImage: 'url(https://d2u7nrdrppwhsn.cloudfront.net/career/department_finance_2018-05.jpg)',
      },
      big: {
        backgroundImage: 'url(https://d2u7nrdrppwhsn.cloudfront.net/career/department_finance_2018-05.jpg)',
      },
    },
  },
  operations: {
    description: 'We reinvent and challenge traditional limitations in logistics, processes and product-care',
    style: {
      small: {
        backgroundImage: 'url(https://d2u7nrdrppwhsn.cloudfront.net/career/department_ops_2018-05.jpg)',
      },
      big: {
        backgroundImage: 'url(https://d2u7nrdrppwhsn.cloudfront.net/career/department_ops_2018-05.jpg)',
      },
    },
  },
  'people_operations': {
    description: 'We are culture builders who empower people and groom leaders to strive to create impact in the world',
    style: {
      small: {
        backgroundImage: 'url(https://d2u7nrdrppwhsn.cloudfront.net/career/department_pops_2018-05_1.jpg)',
      },
      big: {
        backgroundImage: 'url(https://d2u7nrdrppwhsn.cloudfront.net/career/department_pops_2018-05_1.jpg)',
      },
    },
  },
  product: {
    description: 'We turn dreams into reality, literally',
    style: {
      small: {
        backgroundImage: 'url(https://d2u7nrdrppwhsn.cloudfront.net/career/product.jpg)',
      },
      big: {
        backgroundImage: 'url(https://d2u7nrdrppwhsn.cloudfront.net/career/product.jpg)',
      },
    },
  },
  technology: {
    description: 'We build, hack, and experiment with the latest and greatest to delivery quality software to solve real world problems',
    style: {
      small: {
        backgroundImage: 'url(https://d2u7nrdrppwhsn.cloudfront.net/career/tech_mobile.jpg)',
      },
      big: {
        backgroundImage: 'url(https://d2u7nrdrppwhsn.cloudfront.net/career/tech_mobile.jpg)',
        backgroundPosition: 'right',
      },
    },
  },
}

export default props => {
  const departmentId = props.match.params.departmentId
  const departmentIds = departmentList.map(dep => dep.id)
  if (departmentIds.includes(departmentId)) {
    const data = departmentData[departmentId]

    return <Page data={data} />
  }

  return <Redirect to='/404' />
}
